module.exports = __webpack_public_path__ + "img/6.3dfb5eee.png";